import {
	BaseError,
} from './BaseError';

export class PostSpecificationIgnoredUpdatedOfferError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
